import { Modal, SecondaryButton } from '@movingimage-evp/mi-ui-component-library';
import { t } from 'i18next';

import styles from './auto-switch-to-vod-info-modal.module.css';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export function AutoSwitchToVodInfoModal({ isOpen, onClose }: Props) {
  return (
    <Modal
      data-testid="auto-switch-to-vod-info-modal"
      title={t('manager.webcastSetup.eventRecording.options.useRecordingAutomatically.infoModal.title')}
      isOpen={isOpen}
      onClose={onClose}
      contentProps={{ className: styles.modal }}
      footer={
        <SecondaryButton data-testid="auto-switch-to-vod-info-modal-confirm-button" type="button" onClick={onClose}>
          {t('common.confirm')}
        </SecondaryButton>
      }
    >
      {t('manager.webcastSetup.eventRecording.options.useRecordingAutomatically.infoModal.text')}
    </Modal>
  );
}
